import { cloneDeep } from "lodash";
import { ChannelModel } from "../../channel/models/ChannelModel";

export enum ActionTypeEnum {
    UseCurrentForm,
    UseChannelSettings,
}

interface ActionType {
    enum: ActionTypeEnum;
    description: string;
}

export class ProductBatchStockPercentageManagementByChannelModel {
    // idChannel: number|string|null = null;
    channels: string[] = [];
    channelsWrapper?: Array<Partial<ChannelModel>> = [];
    stockPercentage: number|null = null;
    actionTypeList: ActionType[] = [];
    actionType: ActionType|null = null;

    constructor(s?: Partial<ProductBatchStockPercentageManagementByChannelModel>) {
        Object.assign(this, s)

        this._parseActionType();
    }

    isValid():boolean {
        return !!this.isStockPercentageValid();
    }

    hasChannels():boolean {
        return !!this.channelsWrapper?.length;
    }

    isStockPercentageValid():boolean {
        return !!this.stockPercentage &&
            this.stockPercentage > 0 &&
            this.stockPercentage <= 9999;
    }

    isActionTypeUseCurrentForm():boolean {
        return this.actionType?.enum === ActionTypeEnum.UseCurrentForm
    }

    isActionTypeUseChannelSettings():boolean {
        return this.actionType?.enum === ActionTypeEnum.UseChannelSettings
    }

    normalize(): ProductBatchStockPercentageManagementByChannelModel {
        return new ProductBatchStockPercentageManagementByChannelModel({
            // idChannel: this.idChannel,
            actionType: this.actionType,
            actionTypeList: undefined,
            stockPercentage: this.stockPercentage,
            channels: (this.channelsWrapper || []).map((c) => c.id) as string [],
            channelsWrapper: this.channelsWrapper,
        })
    }

    normalizeForRestauration(): ProductBatchStockPercentageManagementByChannelModel {
        return new ProductBatchStockPercentageManagementByChannelModel({
            // idChannel: this.idChannel,
            actionType: this.actionType,
            actionTypeList: undefined,
            channels: (this.channelsWrapper || []).map((c) => c.id) as string [],
            channelsWrapper: this.channelsWrapper,
            stockPercentage: null,
        })
    }

    private _parseActionType():void {
        this.actionTypeList = [
            {enum: ActionTypeEnum.UseCurrentForm, description: 'Utilizar informações configuradas NESTE FORMULÁRIO.'},
            {enum: ActionTypeEnum.UseChannelSettings, description: 'Restaurar informações baseado nas configurações DO CANAL.'},
        ];
        this.actionType = this.actionTypeList.find((at) => at.enum === this.actionType?.enum) || cloneDeep(this.actionTypeList[0])
    }
}

